export default {
  computed: {
    routerTitle() {
      return this.$route.meta.title || ''
    }
  }
}
